import axios from "axios";
import User from "../apis/user"
import { config } from '../util/config'

export default {
    namespaced: true,

    state: {
        userData: null
    },
    
    mutations: {       
        initializeUserData(state) {
            var storedItems = JSON.parse(localStorage.getItem("userData"));
      
            if (storedItems != null){
                state.userData = storedItems
            }  
        },

        setUserData(state, user) {
            state.userData = user;
            localStorage.setItem("userData", JSON.stringify(state.userData));
        },

        updateAccountInfo(state, data) {
            state.userData.name = data.name
            state.userData.phone_number = data.phone_number
            localStorage.setItem("userData", JSON.stringify(state.userData));
        },

        updateLocationInfo(state, data) {
            state.userData.region = data.region
            state.userData.area = data.area
            state.userData.deliveryAddress = data.deliveryAddress
            
            localStorage.setItem("userData", JSON.stringify(state.userData));
        },

        setShipping(state, selectedArea) {
            state.userData.user.shipping_cost = selectedArea.shipping_cost
            state.userData.user.delivery_days = selectedArea.delivery_days

						localStorage.setItem("userData", JSON.stringify(state.userData));
        },

        removeUserInfo(state) {
            state.userData = null
            localStorage.setItem("userData", null)
        }
    },
    
    actions: {
        sendRegisterRequest({ commit }, data) {            
            return axios
                .post(config.backendURL + "/api/register", data)
                .then(response => {
                    var userData = response.data[0]  
                    if(userData) {
                        var user = JSON.parse(response.config.data)
                        userData.id_token = user.id_token 
                        commit("setUserData", userData);
                        return true
                    }            
                })
                .catch(function (error) {
                    alert(error);
                    throw error;
                });
        }, 

        sendLoginRequest({ commit }, data) {            
            return axios
                .post(config.backendURL + "/api/login", data)
                .then(response => {
                    var userData = response.data[0]  
                    if(userData) {
                        var user = JSON.parse(response.config.data)
                        userData.id_token = user.id_token 
                        commit("setUserData", userData);
                        return true
                    }         
                })
                .catch(function (error) {
                    alert(error);
                    throw error;
                });
        }, 

        registerEmail({ commit }, data) {            
            return User.register(data)
                .then(response => {
                    return JSON.parse(
                        `{
                            "status" : true,
                            "message" : "Account created successfully"
                        }`
                    )      
                })
                .catch(function (error) {
                    return JSON.parse(
                        `{
                            "status" : false,
                            "message" : "${error.response.data.message}"
                        }`
                    ) 
                });
        }, 

        loginEmail({ commit }, data) { 
            return User.login(data)
                .then(response => {
                    commit("setUserData", response.data);

                    return JSON.parse(
                        `{
                            "status" : true,
                            "message" : "Success"
                        }`
                    )            
                })   
                .catch(function (error) {
                    return JSON.parse(
                        `{
                            "status" : false,
                            "message" : "${error.response.data.message}"
                        }`
                    )                    
                });
        }, 

        updateAccInfo({ commit }, data) {
            return User.update(data)
                .then(response => {
                    commit("updateAccountInfo", data);

                    return JSON.parse(
                        `{
                            "status" : true,
                            "message" : "Account information updated successfully"
                        }`
                    )            
                })   
                .catch(function (error) {
                    return JSON.parse(
                        `{
                            "status" : false,
                            "message" : "${error.response.data.message}"
                        }`
                    )                    
                });
        },

        updateLocInfo({ commit }, data) {            
            return User.update(data)
                .then(response => {
                    commit("updateLocationInfo", data);

                    return JSON.parse(
                        `{
                            "status" : true,
                            "message" : "Delivery details updated successfully"
                        }`
                    )            
                })   
                .catch(function (error) {
                    return JSON.parse(
                        `{
                            "status" : false,
                            "message" : "${error.response.data.message}"
                        }`
                    )                    
                });
        },

        updateShipping(context, selectedArea) {
            context.commit('setShipping', selectedArea)
        },  
        
        removeUserInfo(context) {
            context.commit('removeUserInfo')
        }
    }
}